<template>
	<div style="padding: 20px;">
		<el-row :gutter="20">
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						发送消息
					</div>
					<div style="padding: 20px;" class="form">
						<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px"
							class="demo-ruleForm" label-position="left">
							<el-form-item label="目标账号" prop="target_account">
								<el-input type="text" placeholder="请输入目标账号" size="small" v-model="ruleForm.target_account"
									style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item label="消息内容" prop="content">
								<el-input type="textarea" :rows="5" placeholder="请输入消息内容" size="small"
									v-model="ruleForm.content" style="width: 300px;"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" size="small" @click="submitForm('ruleForm')">发送微信消息</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
			</el-col>
			<el-col :span="12">
				<div class="centext-box">
					<div class="header">
						消息说明
					</div>
					<div style="padding: 20px;font-size: 14px;color: #ccc;" class="form">
						<div>
							1. 目标账号不是您的微信号，关注微信公众号【权朗网络科技】后，点击下方按钮，获取账号
						</div>
						<div style="margin: 10px 0;">
							2. 这里是测试发送消息，您可以通过程序代码调用本平台的接口发送消息，完成人机单向交互。
						</div>
						<div>
							3. 更多信息请查看帮助信息。
						</div>
					</div>
				</div>
				<div class="centext-box" style="margin-top: 20px;">
					<div class="header">
						帮助
					</div>
					<div style="padding: 20px;font-size: 14px;color: #ccc;" class="form">
						<div>
							1.此功能为收费功能，当前收费为发送一次消息0.01元
						</div>
						<div style="margin: 10px 0;">
							2.接入帮助请用浏览器查看接入文档。
						</div>
						<div>
							3.接入文档地址为：http://wz4.cc/h
						</div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				id: null,
				ruleForm: {
					target_account: '',
					content: '',
				},
				rules: {
					target_account: [{
						required: true,
						message: '请输入目标账号',
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: '请输入消息内容',
						trigger: 'blur'
					}],
				},
			}
		},
		created() {
			this.resetForm()
		},
		methods: {
			submitForm() {
				this.$refs['ruleForm'].validate((valid) => {
					if (valid) {
						this.$H.post('wechat_msg/v1_0_1.Msg/SendMsg',this.ruleForm).then(res => {
							if(res.data){
								this.$message.success('发送成功')
								this.$emit('back')
							}
						});
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm() {
				this.$nextTick(() => {
					this.$refs['ruleForm'].resetFields();
				})
			}
		}
	}
</script>

<style scoped>
	.centext-box {
		border-radius: 5px;
		background-color: rgb(66, 75, 79);
		color: #fff
	}

	.centext-box .header {
		font-size: 14px;
		border-bottom: 1px solid #000;

	}

	.form>>>.el-form-item__label {
		color: #fff !important;
	}

	.form>>>.el-input__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}

	.form>>>.el-radio__label {
		color: #fff;
	}

	.form>>>.el-textarea__inner {
		background-color: rgb(66, 75, 79);
		border: 1px solid #ccc !important;
		color: #fff;
	}
</style>